import { render, staticRenderFns } from "./ModalLocations.vue?vue&type=template&id=00720b0c&lang=pug&"
import script from "./ModalLocations.vue?vue&type=script&lang=js&"
export * from "./ModalLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports